export const list = [
    {
        label: '重庆团建之旅：山水之间，共筑团队梦!',
        text: `金秋十月收获的季节，为感谢每一位奋斗者的辛苦付出，公司组织全体成员四天三晚的重庆旅游以缓解压力，放松心灵，增进友谊。`,
        tags: ['重庆团建',],
        time: '',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseCulture/culture_1.png')
    },
    {
        label: '2023年欢庆年会活动',
        text: `
        <p style="margin-bottom: 16px">
        自古成功无捷径，千锤百炼才成钢。2022年是充满挑战的一年，疫情反复，外部环境艰难。这一年，羿畅人奋勇拼搏，迎难而上，
        将一个个的困难转化为坚定和希望。
        </p>
        <p>
        在奋斗不息的2022年中，涌现出一大批优秀员工，在平凡的岗位创造不凡业绩。公司特对服务模范进行表彰，激励大家继续砥砺前行、
        再创辉煌。
        </p>
        `,
        tags: ['年会活动',],
        time: '2023',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseCulture/culture_2.png')
    },
]
